var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReviewStar = function SvgReviewStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#895FFC",
    fillRule: "evenodd",
    d: "M7.792 1.924a.22.22 0 0 1 .418 0l1.459 4.49h4.721a.22.22 0 0 1 .13.398L10.7 9.587l1.459 4.49a.22.22 0 0 1-.339.246L8 11.547l-3.819 2.776a.22.22 0 0 1-.338-.246l1.459-4.49-3.82-2.775a.22.22 0 0 1 .13-.398h4.72z",
    clipRule: "evenodd"
  })));
};
export default SvgReviewStar;